export enum AccommodationType {
  APARTMENT = "Apartment",
  LOVE_HOTEL = "Love hotel",
  ENTIRE_HOME = "Entire home",
  LODGE = "Lodge",
  COUNTRY_HOUSE = "Country house",
  MOTEL = "Motel",
  CONDOTEL = "Condotel",
  HOSTEL = "Hostel",
  VACATION_HOME = "Vacation home",
  HOMESTAY = "Homestay",
  HOLIDAY_PARK = "Holiday park",
  HOTEL = "Hotel",
  VILLA = "Villa",
  RESORT = "Resort",
  CRUISE = "Cruise",
  INN = "Inn",
  GUEST_HOUSE = "Guest house",
  GLAMPING = "Glamping",
  OTHERS = "Others",
  FARM_STAY = "Farm stay",
}
  